import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Modal, ModalHeader, ModalContent } from '@unbridaled/ui-components'

const ERROR_MODAL_CSS = `.ub-error-msg { display: block; color: inherit; font-size: inherit; }`

interface ErrorModalProps {
  open: boolean
  title?: string | undefined
  onClose?: () => void
  confirm?: string
  message?: string | undefined
  [key: string]: any
}

export const ErrorModal: React.FC<ErrorModalProps> = ({
  open,
  title,
  onClose,
  confirm,
  message = '',
  ...props
}) => {
  const { t } = useTranslation()
  return (
    <>
      <style>{ERROR_MODAL_CSS}</style>
      <Modal
        className="unbridaled-base-popup unbridaled-error"
        open={open}
        {...(onClose !== undefined ? { onClose } : {})}
        {...props}
      >
        <ModalHeader className="unbridaled-popup-title" hideCloseButton>
          {title}
        </ModalHeader>
        <ModalContent className='unbridaled-confirmation-content-wrapper-modal'>
          {message !== '' ? (
            <div className="uui-p-6">
              <span className="ub-error-msg">{message}</span>
            </div>
          ) : null}
        <div className="unbridaled-popup-footer uui-gap-4 uui-flex uui-justify-center uui-border-t uui-border-primary">
          <Button className="uui-flex-1 unbridaled-cancel" onClick={onClose}>
            {confirm ?? t('common.ok')}
          </Button>
        </div>
        </ModalContent>
      </Modal>
    </>
  )
}

export default ErrorModal
